<template>
<div>
	<div class='item' v-show='item.title'>
		<div class='item__main'>
			<h3>{{item.title}}</h3>
			<p v-html='item.text' class='item__text' />
			<div>
				{{pointsCount}} by <b>{{item.by}}</b> | {{timeFromNow}} | {{commentCount}}
			</div>
		</div>
		<div v-if='thereAreKids'>
			<Comment v-for='kid in item.kids' :key='kid.id' :id='kid' />
		</div>

	</div>
	<ScrollToTop />
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import timeFromNow from '../lib/timeFromNow'
import commentCount from '../lib/commentCount'

import Comment from './Comment'
import ScrollToTop from './ScrollToTop'

export default {
	name: 'item',
	props: ['id'],
	components: {
		Comment,
		ScrollToTop
	},
	data: () => ({ item: {} }),
	created: function() {
		this.GET_ITEM(this.$route.params.id)
			.then(() => {
				this.item = this.getItemById(this.$route.params.id)
			})
			.then(() => {
				this.GET_COMMENTS(this.$route.params.id)
			})
	},
	computed: {
		...mapGetters(['getItemById']),
		timeFromNow() {
			return timeFromNow(this.item.time)
		},
		commentCount() {
			return commentCount(this.item.descendants)
		},
		pointsCount() {
			const text = this.item.score <= 1 ? 'point' : 'points'
			return `${this.item.score} ${text}`
		},
		thereAreKids() { return this.item.kids && this.item.kids.length }

	},
	methods: {
		...mapActions(['GET_ITEM', 'GET_COMMENTS'])
	}

}
</script>

<style lang='stylus'>
.item
	margin: auto
	max-width: 1024px

	padding: 1em
	border-radius: 4px

	&__main
		padding: 1em
		background-color: #FFF
		margin-bottom: 2em

	&__text
		max-width: 75%
		margin: 1em auto

</style>
